/** Emoji aus einer Zeichenkette anzeigen (Unicode oder eigenes, auch animiert; fremde werden nachgeladen). */
import { findEmoji, useEmojiUrl } from '../features/messages/emojiCache';
import { parseEmojiString } from '../lib/emojiString';
import { useAppStore } from '../store/app';
import { EmojiGlyph } from './EmojiPicker';
import './emoji.css';

export function EmojiText({ value, size = 18, className }: { value: string | null | undefined; size?: number; className?: string }) {
  const e = parseEmojiString(value);
  const url = useEmojiUrl(e?.id);
  const animatedKnown = useAppStore((s) => (e?.id ? findEmoji(s, e.id)?.animated : undefined));
  if (!e) return null;
  const label = e.id ? `:${e.name}:` : e.name;
  return (
    <span className={`emoji-text-inline ${className ?? ''}`} role="img" aria-label={label} title={label} data-testid="emoji-text">
      <EmojiGlyph emoji={{ ...e, animated: animatedKnown ?? e.animated, url }} size={size} />
    </span>
  );
}
